import React, { useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';

import { DialogProps } from '../types';
import Editor from './components/Editor';

function FolderEditor({ onClose }: DialogProps) {
  const { t } = useTranslation('VisibilitySetting');
  const [formikSubmit, setFormikSubmit] = useState<any>();

  return (
    <Modal
      action={{
        disabled: false,
        text: t('Common:Actions.Save'),
        onSubmit: formikSubmit,
      }}
      header={{
        title: t('Task:Folder.NewFolder'),
        description: t('Task:Folder.NewFolderDescription', { companyName: name }),
      }}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      <Box className="px-24 pt-8 pb-24">
        <Editor setFormikSubmit={setFormikSubmit} onSubmit={console.log} />
      </Box>
    </Modal>
  );
}

export default FolderEditor;
